import React from "react";
import { Grid, ResetPasswordContent } from "../../..";
import { makeStyles, CssBaseline } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    },
    paper: {
      justifyContent: "center"
    }
  };
});

var ResetPassword = function ResetPassword(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    component: "main",
    className: classes.root
  }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(ResetPasswordContent, {
    resetPassword: props.resetPassword,
    forgotPassword: props.forgotPassword,
    email: props.email,
    variant: props.variant
  })));
};

export { ResetPassword };